import {EventEmitter, Injectable} from '@angular/core';
import {ApprovalModel} from '../dto/approval.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {ApprovalPending} from '../dto/approval-pending';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ReversedBlacklistService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/';
  private headers;
  public model = new EventEmitter<NgbModal>();
  public closeModel: NgbModal;
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/searchRequestData', data);
  }

  getAllRequestData(data: ApprovalPending): Observable<Object> {
    console.log(data)
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/getRequestData', data);
  }

  getAllReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/getReturnRequest', data);
  }

  getAllDGReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/getDGReturnRequest', data);
  }

  searchPendingRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/searchPendingRequests', data);
  }

  searchApplicantDetails(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'revered-blacklist/getApplicantDetails/'+ applicationId);
  }

  approveRequeat(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/approveRequest', approvalModel, {headers: this.headers});
  }

  getPendingVerificationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/getPendingRequests',approvalModel,{headers: this.headers});
  }


  getPendingAuthorizationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/getPendingAuthList',approvalModel,{headers: this.headers});
  }

  returnRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-blacklist/returnRequest', approvalModel, {headers: this.headers});
  }


  saveDocumentTypeAndDetails(details) {
    return this.httpClient.post<any>(this.baseUrl + 'revered-blacklist/saveDocumentDetails', details);
  }


  close() {
    this.closeModel.dismissAll();
  }
}
